module.exports = __webpack_public_path__ + "img/7b36806ee34b991add6115adadd156a5.png";